import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterCheckbox,
  TAdvancedFilterSingle,
  TFilterCheckboxOptions,
} from '../../../../models/advanced-filter.model';
import { checkboxOperationOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-checkbox',
  templateUrl: './advanced-filter-checkbox.component.html',
  styleUrls: ['./advanced-filter-checkbox.component.scss'],
  standalone: false,
})
export class AdvancedFilterCheckboxComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterCheckboxOptions;
  filter: TAdvancedFilterCheckbox;

  advancedFilterCheckboxOptions = checkboxOperationOptions;
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterCheckbox;

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterCheckboxOptions;
    this.option = newCondition.value as TFilterCheckboxOptions;

    this.ppFilter.operator = newCondition.operator;
    this.ppFilter.value = newCondition.data;

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: string): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
